module.exports = "/_next/static/images/associationLogo9-06057e0bb766ecd9ab08585f37dc14d1.webp";